import {
  phoneIcon,
  homephoneIcon,
  mailIcon,
  wwwIcon,
  placemarkIcon,
  skypeIcon,
  socialsIcons
} from '@/constants/signatureGmail/svgIconsSignatureType2'
import {
  information,
  awards,
  additionalInformation
} from '@/constants/signatureGmail/resources'
import stylesTemplates from '@/constants/signatureGmail/stylesTemplatesType2'
import {
  setBlock,
  setLink,
  setImg,
  avatarHtml
} from '@/constants/signatureGmail/templatesType2'

const localCompany = {
  "id": "5e0b06b1f3d72e001183707a",
  "name": "Twitter3",
  "image": {
    "id": "5e1f4336e21be80011eb0fb5",
    "label": "King-of-Kings.jpg",
    "path": "https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/5e09ca8f0e8c600011e57b72/images/1579107125809-King-of-Kings.jpg",
    "key": "uploads/5e09ca8f0e8c600011e57b72/images/1579107125809-King-of-Kings.jpg",
    "fieldname": "uploadFile"
  },
  "settings": {
    "vat": 5,
    "usd": 3.67,
    "euro": 3.9
  },
  "website": "start-business.today",
  "skype": "uae-consulting.com",
  "address": "Office 301, Floor 3, Jumeirah Bay X2, Jumeirah Lakes Towers, Dubai, P.O.Box 11111, U.A.E.",
  "socialMedia": [
    {
      "_id": "614dcb74f31ac2004b5b573a",
      "mediaType": "linkedIn",
      "link": "234234"
    },
    {
      "_id": "614dd13ff31ac2004b5b573e",
      "mediaType": "facebook",
      "link": "345345345"
    },
    {
      "_id": "614dd13ff31ac2004b5b573f",
      "mediaType": "twitter",
      "link": "345345"
    },
    {
      "_id": "614dd13ff31ac2004b5b5740",
      "mediaType": "vkontakte",
      "link": "34534534"
    },
    {
      "_id": "614dd13ff31ac2004b5b5741",
      "mediaType": "igtv",
      "link": "345345345"
    },
    {
      "_id": "614eeeff70e51b004074e6bc",
      "mediaType": "youTube",
      "link": "23432"
    },
    {
      "_id": "614eeeff70e51b004074e6bd",
      "mediaType": "telegram",
      "link": "23424"
    },
    {
      "_id": "614eeeff70e51b004074e6be",
      "mediaType": "rss",
      "link": "3435345"
    },
    {
      "_id": "614eeeff70e51b004074e6bf",
      "mediaType": "vkontakte",
      "link": "345345435"
    }
  ],
  "commercialOfferType": 2,
  "signatureType": 2,
  "details": [
    {
      "_id": "614dcb52f31ac2004b5b5738",
      "text": "Company formation and annual support | Регистрация компаний и сопровождение",
      "link": "https://www.youtube.com/watch?v=uLrsQBXSAnw&feature=youtu.be"
    },
    {
      "_id": "614dcb52f31ac2004b5b5739",
      "text": "Resident visas | Оформление виз резидента",
      "link": "https://podcasts.apple.com/ae/podcast/%D0%BF%D0%BE%D0%B4%D0%BA%D0%B0%D1%81%D1%82%D1%8B-uae-consulting-com/id1255782490?mt=2"
    },
    {
      "_id": "614dce1bf31ac2004b5b573b",
      "text": "Bank accounts | Открытие счетов",
      "link": "https://www.youtube.com/playlist?list=PL3JpB3BWN5KBnKjE8RpgX7pOAY0I1erkl"
    },
    {
      "_id": "614dce1bf31ac2004b5b573c",
      "text": "Consulting services | Консультативная поддержка",
      "link": "https://www.youtube.com/playlist?list=PL3JpB3BWN5KCIE-yjgWhCoZ6u32SNAe-o&disable_polymer=true"
    },
    {
      "_id": "614dce1bf31ac2004b5b573d",
      "text": "Web-site development packages | Пакетные предложения по созданию сайтов",
      "link": "https://yadi.sk/i/P9rAUI5j7w2QwQ"
    }
  ],
  "phone": "+ 971 (4) 563-52-54"
}

export default {
  computed: {
    currentCompany () {
      return this.$store.getters.currentCompany || localCompany
    }
  },
  methods: {
    generateSocialsIconsType2 (icons) {
      return icons.reduce((acc, item) => {
        const tag = `<a href=${item.link} target="_blank" style="text-decoration:none; margin:0 2px 0 0">
                        <img alt=" " src="${item.icon}" width="30"/>
                     </a>`
        return item.link ? acc + ' ' + tag : acc
      }, '')
    },
    generateResourcesIconsType2 (resources) {
      return resources.reduce((acc, item, index) => {
        const styles = 'color:#0F0F0F;font-size:12px;line-height:14px;'
        const tag = `<div style="padding:6px 0;">
          <a href=${item.link} target="_blank" style="${styles}">${item.text}</a>
        </div>`
        return item.link ? acc + ' ' + tag : acc
      }, '')
    },
    generateAdditionalType2 (resources) {
      const wrapperStyle = `border: none;
                            font-size: 12px;
                            line-height: 14px;`
      const textStyle = `display: block;
                         color: #838383;
                         text-align: center;`
      const linkStyle = `display: block;
                         font-weight: 500;
                         text-align: center;
                         text-decoration-line: underline;
                         color: #0D7BC4;
                         margin: 2px 0;`
      const iconStyle = `float: left;
                         margin: 15px 6px 15px 0;`
      const itemStyle = `display: block;
                         border: 1px solid #E7E7E7;
                         border-left: 1px solid #FFFFFF;
                         border-right: 1px solid #FFFFFF;
                         box-sizing: border-box;
                         border-radius: 10px;
                         height: 100%;
                         padding: 0 10px;
                         cursor: pointer;
                         transition: 0.3s;
                         margin-right: 16px;`
      const cell = resources.reduce((acc, item) => {
        const tag = `<td style="${wrapperStyle}; min-width: ${item.width}; width: ${item.width}; height: 66px">
                       <a href="${item.href}"
                          class="bb-email-link"
                          target="_blank"
                          style="${itemStyle}">
                         <span>
                           <img src="${item.icon}" alt="icon" width="36" height="36" style="${iconStyle}"/>
                         </span>
                         <div style="float: right; margin-top: 10px">
                           <span style="${textStyle}">${item.title.en}</span>
                           <span style="${linkStyle}">${item.link}</span>
                           <span style="${textStyle}">${item.title.ru}</span>
                         </div>
                       </a>
                     </td>`
        return acc + ' ' + tag
      }, '')
      return `<table bgcolor="#ffffff" border="0" cellpadding="0" cellspacing="0"><tr>${cell}</tr></table>`
    },
    generateAwardsImgType2 (resources) {
      return resources.reduce((acc, item) => {
        const tag = `<img alt=" " src="${item}" width="98" style="margin: 0 4px 0 0"/>`
        return acc + ' ' + tag
      }, '')
    },
    generateSignatureType2 ({photo, username, position, phone, email}) {
      const { skype, website, address, socialMedia, details, phone: companyPhone } = this.currentCompany
      const mainTdStyles = 'color:#838383;padding:0 0 0 0;vertical-align:top;' +
        'border: none; width: auto; font-family:Helvetica,Arial,sans-serif;'
      const socialLinks = socialMedia.map((soc) => {
        const { link, mediaType } = soc
        if (link) {
          const currentSocial = socialsIcons.find((item) => item.mediaType === mediaType)
          return {
            ...currentSocial,
            link
          }
        }
      })
      const socialsHtml = this.generateSocialsIconsType2(socialLinks)
      const resourcesHtml = this.generateResourcesIconsType2(details)
      // const additional = this.generateAdditional(additionalInformation)
      // phones
      const phoneIconBlock = setImg(phoneIcon, 'phone icon')
      const phoneBlock = setLink(stylesTemplates.phone, 'tel:' + phone, phone)
      const phoneHtml = phoneBlock ? `<div style="margin: 0 0 5px">${phoneIconBlock}${phoneBlock}</div>` : ''
      const homePhoneIconBlock = setImg(homephoneIcon, 'home phone icon')
      const homePhoneBlock = setLink(stylesTemplates.companyPhone,  'tel:' + companyPhone, companyPhone)
      const homePhoneHtml = `<div>${homePhoneIconBlock}${homePhoneBlock}</div>`
      const phonesHtml = phoneHtml + homePhoneHtml
      // mail address
      const mailIconBlock = setImg(mailIcon, 'mail icon')
      const mailLink = setLink(stylesTemplates.emailStyle, 'mailto:' + email, email)
      const mailHtml = mailIconBlock + mailLink
      // skype address
      const skypeIconBlock = setImg(skypeIcon, 'skype icon')
      const skypeLink = setLink(stylesTemplates.emailStyle, 'skype:' + skype + '?call', skype)
      const skypeHtml = skype ? skypeIconBlock + skypeLink : null
      // website address
      const websiteIcon = setImg(wwwIcon, 'globe icon')
      const websiteLink = setLink(stylesTemplates.companySiteStyle, 'https://' + website, website)
      const websiteHtml = website ? websiteIcon + websiteLink : null
      // geo address
      const addressIcon = setImg(placemarkIcon, 'placemark icon')
      const addressBlock = setBlock(stylesTemplates.companyAddress, address)
      const addressHtml = address ? addressIcon + addressBlock : null
      return `<br>
      <br>
      <div style="width:100%;max-width: 975px;font-family:Helvetica,Arial,sans-serif;">
        <table bgcolor="#ffffff" border="0" cellpadding="0" cellspacing="0">
          <tbody>
            <tr>
              <td
                valign="top"
                style="
                    padding:0 40px 0 0;
                    width: 158px;
                    max-width: 158px;
                    border: none;
                    vertical-align: top;
                    box-sizing: content-box;
                    font-family:Helvetica,Arial,sans-serif;
                "
              >
                ${avatarHtml(photo)}
              </td>
              <td valign="top" style="${mainTdStyles}">
                ${setBlock(stylesTemplates.username, username)}
                ${setBlock(stylesTemplates.position, position)}
                ${setBlock(stylesTemplates.block, phonesHtml)}
                ${setBlock(stylesTemplates.block, mailHtml)}
                ${setBlock(stylesTemplates.block, skypeHtml)}
                ${setBlock(stylesTemplates.block, websiteHtml)}
                ${setBlock(stylesTemplates.block, addressHtml)}
                ${setBlock(stylesTemplates.socialsIcons, socialsHtml)}
                ${setBlock(stylesTemplates.awards, resourcesHtml)}
                ${setBlock(stylesTemplates.information, information)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>`
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/signatureGeneratorType2.js